import { useEffect, useRef, useCallback } from 'react';
import { throttle } from 'throttle-debounce';
import { useOnIntersection } from '../../hooks';
import { getIntersectionData } from '../../utils';
export var THROTTLE_DELAY = 100;
export var EVENTS = ['scroll', 'resize'];
export var useOldStickyProps = function useOldStickyProps(props) {
  var onBottomStuck = props.onBottomStuck,
    onTopStuck = props.onTopStuck,
    children = props.children,
    root = props.root;
  var sentinelRef = useRef(null);
  var _useOnIntersection = useOnIntersection({
      onBottomStuck: onBottomStuck,
      onTopStuck: onTopStuck
    }),
    onIntersection = _useOnIntersection.onIntersection,
    isOnBottomStuck = _useOnIntersection.isOnBottomStuck,
    isOnTopStuck = _useOnIntersection.isOnTopStuck;
  var computeIsSticky = useCallback(function () {
    if (sentinelRef.current) {
      var sentinelClientRect = sentinelRef.current.getBoundingClientRect();
      onIntersection(getIntersectionData(sentinelClientRect, root));
    }
  }, [root, onIntersection]);

  // NOTE: необходимо для определения положения при инициализации
  useEffect(function () {
    if (children) {
      computeIsSticky();
    }
  }, [computeIsSticky, children]);
  useEffect(function () {
    var element = root || window;
    var throttledComputing = throttle(THROTTLE_DELAY, computeIsSticky);
    EVENTS.forEach(function (event) {
      return element.addEventListener(event, throttledComputing);
    });
    return function () {
      EVENTS.forEach(function (event) {
        return element.removeEventListener(event, throttledComputing);
      });
    };
  }, [root, computeIsSticky]);
  return {
    sentinelRef: sentinelRef,
    isOnBottomStuck: isOnBottomStuck,
    isOnTopStuck: isOnTopStuck
  };
};